import React,{ useRef, useState } from "react";
import Button from "./atoms/Button";
import { ArrowRight } from "lucide-react";
const defaultFaqList = [
   {
    question: "Is Roach Home Improvement licensed and insured?",
    answer: <div className="space-y-2 leading-relaxed">Yes. State of Michigan license # 2101200181, Workers Compensation and Liability through Frankenmuth Insurance.</div>,
   },
    {
      question: "How long has Roach Home Improvement been in business?",
      answer: <div className="space-y-2 leading-relaxed">We have been in business for 20 years doing roof installations and many other Roofing projects.</div>,
    },
    {
      question: "Does Roach Home Improvement remove old roofing material or shingle over the existing roof?",
      answer: <div className="space-y-2 leading-relaxed">We do not recommend applying a new layer of shingles over the existing roof. At Roach we want to remove all existing roofing material to insure that the roof decking is adequate for the new roof application (No rotten wood or large gaps). Michigan code states no more than 2 layers of roofing materials plus total removal for the manufacturers warranty.</div>,
    },
    {
      question: "Why is your price higher than some of your competitors?",
      answer: <div className="space-y-2 leading-relaxed">At Roach Home Improvement, we are not always the lowest estimate because we are licensed & insured (this is your legal protection), along with standing behind our installations. If you have questions, we will address your concerns during and after the installation (No hit & run with us) Our experienced project managers and crew leaders will be with you from start to finish.</div>,
    },
    {
      question: "How long will the roofing application take on my home?",
      answer: <div className="space-y-2 leading-relaxed">No one answer to this because each home is different. An easy 1 story gable or hip roof house will be complete in 1 day. A 2 story multi slope roof with multiple layers of removal will be complete in 2 days. </div>,
    }
];

const jacksonFaqList = [
  {
    question: "How often should I have my roof inspected in Jackson?",
    answer: <div className="space-y-2 leading-relaxed">You should have your roof inspected at least once a year, ideally in the spring or fall. Jackson's weather can be tough on roofs, with heavy snow in winter and storms throughout the year. Annual inspections help catch small problems before they turn into expensive repairs. If you've experienced severe weather like high winds or hail, it's smart to schedule an additional inspection right away.</div>,
  },
  {
    question: "How do I know if my roof needs repair or replacement?",
    answer: <div className="space-y-2 leading-relaxed">Look for warning signs like missing or curling shingles, dark spots or streaks, granules in your gutters, or leaks inside your home. If your roof is over 20 years old, it's probably time to consider replacement. However, minor damage like a few missing shingles can often be repaired. The best way to know for sure is to have a professional inspection. We'll assess the damage and give you an honest recommendation based on your roof's condition.</div>,
  },
  {
    question: "How long will a roof replacement take in Jackson?",
    answer: <div className="space-y-2 leading-relaxed">Most residential roof replacements in Jackson take 1 to 3 days, depending on the size of your home and the complexity of the job. Weather can affect the timeline, especially during Michigan's unpredictable seasons. We'll give you a clear schedule before we start and keep you updated throughout the process. Our goal is to work efficiently while ensuring quality craftsmanship.</div>,
  },
  {
    question: "Do you offer emergency roofing services in Jackson?",
    answer: <div className="space-y-2 leading-relaxed">Yes, we offer 24/7 emergency roofing services. When disaster strikes, whether it's storm damage, a sudden leak, or a tree falling on your roof, we respond quickly. Our team will assess the damage, perform temporary repairs to protect your home, and then work with you on a permanent solution. Roofing emergencies don't wait, and neither do we.</div>,
  },
  {
    question: "How can I prevent ice dams on my Jackson roof?",
    answer: <div className="space-y-2 leading-relaxed">Prevent ice dams by keeping heat from escaping into your attic. Proper insulation and ventilation are key. They keep your roof cold so snow melts evenly instead of refreezing at the edges. Seal air leaks around attic hatches, fans, and light fixtures. During winter, clear snow from your roof edges after heavy storms and keep gutters clean. If ice dams are a recurring problem, we can inspect your attic and identify insulation or ventilation issues.</div>,
  },
  {
    question: "Are your roofing contractors licensed and insured in Jackson?",
    answer: <div className="space-y-2 leading-relaxed">Yes, all our roofing contractors are fully licensed and insured to work in Jackson, MI. We carry comprehensive liability insurance and workers' compensation coverage to protect you and your property. Our team is trained, experienced, and committed to following all local building codes and safety standards. You can have peace of mind knowing your roof is in professional hands.</div>,
  },
];

const wyomingFaqList = [
  {
    question: "How often should I have my roof inspected in Wyoming, MI?",
    answer: <div className="space-y-2 leading-relaxed">You should schedule a professional roof inspection at least once a year, and after major storms. Regular inspections help catch small issues early and prevent costly repairs.</div>,
  },
  {
    question: "How do I know if my roof needs repair or full replacement?",
    answer: <div className="space-y-2 leading-relaxed">You can usually tell whether your roof needs repair or full replacement by looking at the age of the roof, the type of damage, and how widespread the issues are.</div>,
  },
  {
    question: "How long will a roof replacement take in Wyoming, MI?",
    answer: <div className="space-y-2 leading-relaxed">Most roof replacements in Wyoming, MI are completed in one day, especially for standard asphalt shingle roofs on single-family homes. Larger roofs, steeper slopes, multiple shingle layers, or unexpected repairs to the roof decking can extend the project to two or more days. Weather conditions such as rain, snow, or high winds may also affect the timeline.</div>,
  },
  {
    question: "Can roof repairs be done in winter in Wyoming, MI?",
    answer: <div className="space-y-2 leading-relaxed">Yes, many roof repairs can be safely performed during winter, especially emergency leak repairs. However, some repairs may be weather-dependent due to temperature or snow conditions. Temporary solutions may be used until permanent repairs can be completed safely.</div>,
  },
  {
    question: "How can I prevent ice dams on my Wyoming, MI roof?",
    answer: (
      <div className="space-y-2 leading-relaxed">
        <p>You can prevent ice dams on your roof in Wyoming, MI by keeping heat from escaping into your attic. Proper insulation and ventilation are your best defense. They keep your roof cold so snow melts evenly instead of refreezing at the edges.</p>
        <p>Seal up any air leaks around attic hatches, fans, and light fixtures to stop warm air from sneaking in. During winter, clear snow from your roof edges after heavy storms and make sure your gutters are clean so melted snow can drain.</p>
      </div>
    ),
  },
  {
    question: "Are your roofing contractors licensed and insured in Wyoming, MI?",
    answer: <div className="space-y-2 leading-relaxed">Yes, all our roofing contractors are fully licensed and insured to work in Wyoming, MI. We carry comprehensive liability insurance and workers' compensation coverage to protect you and your property.</div>,
  },
];

// Keyed by city, then service slug. Both city lists are roofing questions, so
// they belong on the roofing page only; every other page gets the default list.
const cityFaqLists = {
  jackson: { roofing: jacksonFaqList },
  wyoming: { roofing: wyomingFaqList },
};

const getFaqList = (city, service) => {
  if (!city) return defaultFaqList;
  const byService = cityFaqLists[String(city).trim().toLowerCase()];
  return (byService && byService[service]) || defaultFaqList;
};


const Item = ({ item }) => {
  const accordion = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li>
      <button
        className="relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        aria-expanded={isOpen}
      >
        <span
          className={`font-display flex-1 text-base-content ${isOpen ? "text-primary" : ""}`}
        >
          {item?.question}
        </span>
        <svg
          className={`flex-shrink-0 w-4 h-4 ml-auto fill-current`}
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="7"
            width="16"
            height="2"
            rx="1"
            className={`transform origin-center transition duration-200 ease-out ${
              isOpen && "rotate-180"
            }`}
          />
          <rect
            y="7"
            width="16"
            height="2"
            rx="1"
            className={`transform origin-center rotate-90 transition duration-200 ease-out ${
              isOpen && "rotate-180 hidden"
            }`}
          />
        </svg>
      </button>

      <div
        ref={accordion}
        className={`transition-all duration-300 ease-in-out opacity-80 overflow-hidden`}
        style={
          isOpen
            ? { maxHeight: accordion?.current?.scrollHeight, opacity: 1 }
            : { maxHeight: 0, opacity: 0 }
        }
      >
        <div className="pb-5 leading-relaxed">{item?.answer}</div>
      </div>
    </li>
  );
};


const FAQ = ({ title, classnames, city, service }) => {
  const faqList = getFaqList(city, service);

  return (
    <div className={`relative py-16 bg-neutral-100  overflow-hidden ${classnames}`}>
      
       <div className="max-w-7xl mx-auto  flex  justify-center">
       
        <div className="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block" aria-hidden="true">
              <svg
                className="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect x={0} y={0} width={4} height={4} className="text-neutral-200" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
              </svg>
              <svg
                className="absolute top-full transform -translate-y-1/3 -translate-x-1/3 xl:-translate-y-1/2"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect x={0} y={0} width={4} height={4} className="text-neutral-200" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
              </svg>
            </div>
        
          

             
            <div className="relative w-full max-w-3xl  md:py-12 px-4 space-y-4  sm:py-12 sm:px-6 ">
              <h2 className="text-center text-3xl md:text-4xl font-display text-nuetral-900 font-extrabold">
              Frequently Asked Questions
              </h2>
              <p className="text-neutral-600 text-lg text-center">
              Home owners have questions, Roach Home Improvement provides answers.
              </p>
             
              <ul className="basis-1/2 mt-4">
          {faqList.map((item, i) => (
            <Item key={i} item={item} />
          ))}
        </ul>
              <Button
              size="big"
              color="red"
                  to="/contact/"
                title={"Get Started with " + title}
                >
                Ask a Question<ArrowRight size={16} className="ml-2"/>
              </Button>
            </div>
           
      </div>
    </div>
  );
};
 

export default FAQ;
